import React, { useState } from 'react';
import { FiLock, FiEye, FiEyeOff, FiAlertCircle } from 'react-icons/fi';
import styles from '../Auth.module.css';

/**
 * PasswordInput - Password field with show/hide toggle and strength indicator
 */
const PasswordInput = ({
  label = 'Password',
  error,
  showStrength = false,
  strength = { score: 0, message: '' },
  id,
  className = '',
  ...inputProps
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputId = id || 'password-input';

  // Get strength level class
  const getStrengthClass = () => {
    if (strength.score <= 1) return styles['au-password-strength--weak'];
    if (strength.score === 2) return styles['au-password-strength--fair'];
    if (strength.score === 3) return styles['au-password-strength--good'];
    return styles['au-password-strength--strong'];
  };

  return (
    <div className={styles['au-input-group']}>
      {label && (
        <label 
          htmlFor={inputId}
          className={styles['au-input-group__label']}
        >
          {label}
        </label>
      )}
      
      <div className={styles['au-input-group__wrapper']}>
        <span className={styles['au-input-group__icon']}>
          <FiLock />
        </span>
        
        <input
          id={inputId}
          type={showPassword ? 'text' : 'password'}
          className={`
            ${styles['au-input']} 
            ${error ? styles['au-input--error'] : ''}
            ${className}
          `.trim()}
          {...inputProps}
        />
        
        <button
          type="button"
          className={styles['au-input-group__toggle']}
          onClick={() => setShowPassword(!showPassword)}
          tabIndex={-1}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
        </button>
      </div>

      {/* Password Strength Indicator */}
      {showStrength && inputProps.value && (
        <div className={`${styles['au-password-strength']} ${getStrengthClass()}`}>
          <div className={styles['au-password-strength__bars']}>
            <div className={styles['au-password-strength__bar']} />
            <div className={styles['au-password-strength__bar']} />
            <div className={styles['au-password-strength__bar']} />
            <div className={styles['au-password-strength__bar']} />
          </div>
          <span className={styles['au-password-strength__text']}>
            {strength.message}
          </span>
        </div>
      )}
      
      {error && (
        <div className={styles['au-input-group__error']}>
          <FiAlertCircle size={14} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
